export default Object.freeze({
  Equal: 1,
  GreaterThan: 2,
  LessThan: 3,
  Contains: 4,
});
